import { post } from "../base";
import { get } from "../base";

//机构信息
export async function getJgInfo() {
    let respObj = await get("/edu-classroom/user/current-user-info");
    return respObj;
}
//更改手机号  
export async function orgUpdatePhone(params) {
    let respObj = await get("/org/orgUpdatePhone",params);
    return respObj;
}

//更改机构基本信息
export async function updateorg(params){
    return await post('/org/updateorg', params);
}

//获取讲师列表
export async function getOrgLecturerPageList(params){
    return await get("/edu-classroom/lecturer/getOrgLecturerPageList",params)
}

//添加讲师
export async function addTeacher(params){
    return await post('/edu-classroom/lecturer/orgAddLecturer', params);
}

//删除讲师
export async function delTeacher(params) {
    let respObj = await get("/edu-classroom/lecturer/orgDelLecturer",params);
    return respObj;
}

//修改讲师  
export async function updateTeacher(params){
    return await post('/edu-classroom/lecturer/orgUpdateLecturer', params);
}